<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        // this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      // this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      console.log("年龄段分布数据", data);
      let _this = this;
      if (!this.chart) {
        return;
      }
      let setOptionStyle = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
          backgroundColor: 'rgba(255,255,255,1)'
        },
        legend: {
          top: "10",
          textStyle: {
            color: _this.isbig ? "#AABEFF" : "",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "50",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "",
          },
        },
        yAxis: {
          type: "category",
          data: data.xAxisData,
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "",
          },
        },
        series: [
          {
            name: "5-8岁",
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [
              10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
              10,
            ],
          },
          {
            name: "9-12岁",
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [
              10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
              10,
            ],
          },
          {
            name: "13-15岁",
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [
              10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
              10,
            ],
          },
          {
            name: "16-18岁",
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [
              10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
              10,
            ],
          },
          {
            name: "19-22岁",
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [
              10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
              10,
            ],
          },
          {
            name: "23-25岁",
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [
              10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
              10,
            ],
          },
        ],
      }
      setOptionStyle.series = [];
      for (var key in data.seriesList) {
        let seriesStyle = {
          name: "",
          type: "bar",
          stack: "total",
          label: {
            show: true,
          },
          emphasis: {
            focus: "series",
          },
          data: [],
        }
        seriesStyle.name = data.seriesList[key].name
        seriesStyle.data = data.seriesList[key].data
        setOptionStyle.series.push(seriesStyle);
      }
      this.chart.setOption(setOptionStyle);
    },
  },
};
</script>
